module.exports = __webpack_public_path__ + "img/list_bullet.4ac81344.svg";